import React, { useState, Fragment } from 'react';
import { TemplateMessengerList } from './TemplateMessengerList';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { gAPI_CopyServices } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

function TemplateMessengerButton({ propertyId, domains, LoadData, isServiceOrder }) {
    const [visible, setVisible] = useState(false);
    const handleSubmit = data => {
        AxiosAPI({
            method: 'post',
            url: `${gAPI_CopyServices}`,
            data,
        })
            .then(
                res => {
                    setVisible(!visible)
                    LoadData();
                }
            )
            .catch(err => {
                console.log('err', err);
            });
    };

    return (
        <Fragment>
            <Button
                color="primary"
                size="lg"
                className="top-right-button mr-1"
                onClick={() => {
                    setVisible(!visible);
                }}
            >
                + Add From Templates
            </Button>


            <TemplateMessengerList
                formLabel="Template Messenger List"
                visible={visible}
                toggle={() => {
                    setVisible(!visible);
                }}
                submit={handleSubmit}
                propertyId={propertyId}
                domainName={domains}
                isServiceOrder={isServiceOrder}
            />
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, domains } = settings;
    return {
        propertyId,
        domains
    };
};

export default injectIntl(connect(mapStateToProps, {})(TemplateMessengerButton));

TemplateMessengerButton.propTypes = {
    propertyId: PropTypes.string.isRequired,
};
